<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-title page-title">
      <p>学习数据统计</p>
      <span @click="backPre">返回</span>
    </div>
    <div class="panel-content center_content">
      <div class="course_info">
        <div class="panel-title">
          <p v-if="lessonInfo">{{ lessonInfo ? lessonInfo.title : '' }}</p>
          <p v-if="lessonInfo">负责人:{{  lessonInfo.manager &&  lessonInfo.manager ? lessonInfo.manager.name : '' }}</p>
        </div>
        <div class="course_btn">
          <div v-show="false"></div>
          <!-- <router-link
            tag="div"
            :to="'/www/lesson_detail?id=' + lessonInfo.id"
            class="add-btn"
          >预览</router-link> -->
        </div>
      </div>
      <!-- 学习进度 -->
      <div class="content study-speed">
        <ul class="section">
          <li>
            <div class="section-title">
              <span>预习</span>
              <div class="progress-bg">
                <span>{{getCount(studyProcessData.preview).toFixed(2)}}%</span>
                <div
                  class="skills progress"
                  :style="`width:${getCount(studyProcessData.preview)}%`"
                ></div>
              </div>
            </div>
            <div>
              <div
                class="section-discuss"
                v-for="item in studyProcessData.preview"
                :key="item.id"
              >
                <div>
                  <i
                    class="iconfont"
                    :style="`${item.finished?'color:#25b864':''}`"
                  >{{item.finished?'&#xe64d;':'&#xe64e;'}}</i>
                  <span style="color:#019999">【{{item.studyType?'实验预习':'理论预习'}}】</span>
                  <span>{{item.title}}</span>
                </div>
                <span
                  class="viewgrade"
                  v-if="item.studyType"
                  @click="goViewScore(item)"
                >查看成绩</span>
              </div>
              <div
                class="section-discuss no-more"
                v-if="!studyProcessData.preview.length"
              >
                暂无数据
              </div>
            </div>
          </li>
          <li>
            <div class="section-title">
              <span>学习</span>
              <div class="progress-bg">
                <span>{{getCount(studyProcessData.study).toFixed(2)}}%</span>
                <div
                  class="skills progress"
                  :style="`width:${getCount(studyProcessData.study)}%`"
                ></div>
              </div>
            </div>
            <div>
              <div
                class="section-discuss"
                v-for="item in studyProcessData.study"
                :key="item.id"
              >
                <div>
                  <i
                    class="iconfont"
                    :style="`${item.finished?'color:#25b864':''}`"
                  >{{item.finished?'&#xe64d;':'&#xe64e;'}}</i>
                  <span style="color:#019999">【{{item.studyType?'实验学习':'理论学习'}}】</span>
                  <span>{{item.title}}</span>
                </div>
                <span
                  class="viewgrade"
                  v-if="item.studyType"
                  @click="goViewScore(item)"
                >查看成绩</span>
              </div>
              <div
                class="section-discuss  no-more"
                v-if="!studyProcessData.study.length"
              >
                暂无数据
              </div>
            </div>
          </li>
          <li>
            <div class="section-title">
              <span>测试</span>
              <div class="progress-bg">
                <span>{{getCount(studyProcessData.exam).toFixed(2)}}%</span>
                <div
                  class="skills progress"
                  :style="`width:${getCount(studyProcessData.exam)}%`"
                ></div>
              </div>
            </div>
            <div>
              <div
                class="section-discuss"
                v-for="item in studyProcessData.exam"
                :key="item.id"
              >
                <div>
                  <i
                    class="iconfont"
                    :style="`${item.finished?'color:#25b864':''}`"
                  >{{item.finished?'&#xe64d;':'&#xe64e;'}}</i>
                  <span style="color:#019999">【{{item.studyType?'实验测试':'理论测试'}}】</span>
                  <span>{{item.title}}</span>
                </div>

                <div class="viewgrade">
                  <span @click="viewResult(item.onlineStudentExamId)">查看试卷</span>
                  <span style="color: black; margin-left: 20px;">得分：{{item.grade?item.grade:'--'}}</span>
                </div>
              </div>
              <div
                class="section-discuss  no-more"
                v-if="!studyProcessData.exam.length"
              >
                暂无数据
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <ExamResult
      :show="onlineStudentExamShow"
      :id="onlineStudentExamId"
      :closeExamResultWindow="closeViewResult"
    ></ExamResult>
  </div>
</template>

<script>
import ExamResult from '../../../components/ExamResult'

export default {
  name: 'OnlineTeacher',
  components: {
    ExamResult
  },
  props: [
    'lessonInfo'
  ],
  data() {
    return {
      studyProcessData: {
        preview: [],
        study: [],
        exam: []
      },
      onlineStudentExamId: 0,
      onlineStudentExamShow: false
    }
  },

  methods: {
    async getStudyProgress() {
      const url = '/online_student_study_process/'
      await this.$http.get(url, {
        params: {
          onlineStudentId: this.$route.query.studentId
        }
      }).then((data) => {
        this.studyProcessData = data.data
      }).catch((error) => {
        console.log(error)
      })
    },
    getCount (item) {
      var sum = 0
      if (item) {
        for (let i = 0; i < item.length; i++) {
          sum = sum + item[i].finished
        }
        return item.length ? (sum / item.length).toFixed(2) * 100 : item.length
      } else {
        return 0
      }
    },
    backPre() {
      this.$router.go(-1)
    },
    goViewScore(item) {
      console.log(item)
      this.$router.push('/online/statistics/view/achievement?id=' + this.$route.query.id + '&experiment_id=' + item.experiment_id + '&studyId=' + item.id + '&studentId=' + this.$route.query.studentId)
    },
    async viewResult (onlineStudentExamId) {
      this.onlineStudentExamId = onlineStudentExamId
      this.onlineStudentExamShow = true
    },
    closeViewResult () {
      this.onlineStudentExamShow = false
    }
  },
  mounted() {
    this.getStudyProgress()
  },
  computed: {

  }
}
</script>
<style scoped src="@/assets/css/project-detail.css"></style>
<style lang="less" scoped>
.panel-content {
  padding: 20px 40px;
}
.c-content {
  margin: 0;
  transform: translate(-50%, -50%);
}
.content {
  margin-top: 20px;
  min-height: 450px;
}
#c-panel {
  z-index: 2;
}
.c-content {
  min-height: 650px;
}
.active {
  color: #266dc7 !important;
  text-decoration: underline;
}
.course_info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  .panel-title {
    p {
      display: inline-block;
      margin-right: 20px;

      &:last-child {
        color: #999;
        font-size: 16px;
      }
    }
  }
  .course_btn {
    div {
      margin-left: 20px;
      padding: 7px 20px;
      background: #73D6CA;
      color: #fff;
      border-radius: 3px;
      &:first-child {
        background: #25c7a8;
      }
      &:nth-child(2) {
        border: 1px solid #73D6CA;
        color: #73D6CA;
        background: #fff;
      }
    }
  }
}
.crumb_nav {
  color: #999;
  margin-top: 20px;
}
.add-btn {
  width: unset;
  height: unset;
  line-height: normal;
}
.progress-time {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .begin-study {
    background-color: #73D6CA;
    color: #fff;
    padding: 10px 15px;
    border-radius: 5px;
    margin-left: 20px;
    cursor: pointer;
  }
}
.progress-bg {
  width: 50%;
  background-color: #ddd;
  border-radius: 15px;
  margin-right: 20px;
  overflow: hidden;
}
.skills {
  text-align: right;
  line-height: 20px;
  color: white;
  border-radius: 15px;
}
.progress {
  width: 20%;
  height: 20px;
  background-color: #4caf50;
}
// 学习进度
.section {
  li {
    color: #555;
    .section-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      line-height: 40px;
      padding: 0 40px;
      .progress-bg {
        width: 20%;
        position: relative;
        span {
          font-size: 12px;
          position: absolute;
          left: 5px;
          top: 50%;
          transform: translateY(-50%);
          line-height: 0;
        }
        .progress {
          padding: 0;
          height: 15px;
        }
      }
    }
    .section-title,
    .section-discuss,
    .section-homework,
    .section-study,
    .section-test {
      font-size: 14px;
      border-bottom: 1px solid #eee;
      &:hover {
        background: #f0f9f9;
      }
    }
    .section-discuss,
    .section-homework,
    .section-study,
    .section-test {
      display: flex;
      justify-content: space-between;
      align-items: center;
      line-height: 40px;
      padding: 0 60px;
      .grade {
        span:nth-child(1) {
          color: #73D6CA;
        }
        span {
          margin-left: 50px;
        }
      }
    }
    .no-more {
      justify-content: center;
    }
  }
}
.page-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  span {
    background: #73D6CA;
    color: #fff;
    padding: 5px 10px;
    border-radius: 5px;
    font-size: 14px;
    line-height: normal;
    cursor: pointer;
  }
}
.viewgrade {
  display: block;
  width: 20%;
  color: #73D6CA;
  cursor: pointer;
}
</style>
